// extracted by mini-css-extract-plugin
export default {"wrapper":"PimoIXCB","header":"mSaYeStE"};